import React from "react";
import { Link } from "react-router-dom";
import { blogPosts } from "@/data/blogData";

const BlogPage = () => {
  const postsList = Object.values(blogPosts);

  return (
    <div className="w-full bg-[#0f0f0f] text-[#f2f2f2] min-h-screen">
      <div className="max-w-[1100px] mx-auto px-5 py-[80px] md:py-[120px]">
        {/* Header */}
        <div className="mb-2">
          <span className="text-[11px] uppercase tracking-[0.12em] text-[#555555] border border-[#222222] px-3 py-1 rounded inline-block font-mono">
            BLOG
          </span>
        </div>
        <h1
          className="text-[36px] sm:text-[48px] font-bold text-[#f2f2f2] mb-3"
          style={{ fontFamily: "'DM Sans', sans-serif" }}
        >
          Builder Notes
        </h1>
        <p className="text-[15px] text-[#666666] mb-[60px] max-w-xl">
          Things I've learned shipping products solo. No fluff, no motivation posts.
        </p>

        {/* Post List */}
        <div className="divide-y divide-[#1a1a1a] border-t border-b border-[#1a1a1a]">
          {postsList.map((post) => (
            <article key={post.slug} className="py-8 group">
              <Link to={`/blog/${post.slug}`} className="block">
                <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
                  <div className="flex items-center space-x-3">
                    {post.tags.map((tag) => (
                      <span
                        key={tag}
                        className="bg-[#1e1e1e] text-[#888888] text-[11px] px-[10px] py-[4px] rounded-[4px] font-mono"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <span className="text-xs text-[#555555] font-mono">{post.date}</span>
                </div>

                <h2
                  className="text-[22px] sm:text-[26px] font-bold text-[#f2f2f2] group-hover:text-white transition-colors mb-3"
                  style={{ fontFamily: "'DM Sans', sans-serif" }}
                >
                  {post.title}
                </h2>

                <p className="text-[14px] text-[#888888] leading-relaxed max-w-3xl mb-4">
                  {post.excerpt}
                </p>

                <div className="text-sm text-[#f2f2f2] font-medium group-hover:underline underline-offset-4 decoration-[#333333] inline-flex items-center gap-1">
                  Read post →
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlogPage;
